import { render, staticRenderFns } from "./PurchaseOptionCard.vue?vue&type=template&id=9da06c2c&scoped=true"
import script from "./PurchaseOptionCard.vue?vue&type=script&lang=ts"
export * from "./PurchaseOptionCard.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOptionCard.vue?vue&type=style&index=0&id=9da06c2c&prod&lang=scss&scoped=true"
import style1 from "./PurchaseOptionCard.vue?vue&type=style&index=1&id=9da06c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da06c2c",
  null
  
)

export default component.exports